import { render } from "./CategoryProductSorter.vue?vue&type=template&id=03dc27e5&scoped=true"
import script from "./CategoryProductSorter.vue?vue&type=script&lang=js"
export * from "./CategoryProductSorter.vue?vue&type=script&lang=js"

import "./CategoryProductSorter.vue?vue&type=style&index=0&id=03dc27e5&scoped=true&lang=css"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03dc27e5"]])

export default __exports__